import { Menu } from '@mantine/core';
import React from 'react';
import PrimaryDropDown from 'app/views/components/DropDown/DropDown';

interface Props<T> {
  selectedItems: T[]
  actions: {
    [key: string]: () => void
  };
  clearSelectedItems: () => void
  menuIcons?: {
    [key: string]: React.ReactNode
  }
}

const BulkActionsButton = <T,>({ selectedItems, actions, clearSelectedItems, menuIcons }: Props<T>) => {

  return (
    <Menu shadow="md" width="auto" position="bottom-start">
      <Menu.Target>
        <PrimaryDropDown isCreateNew data-testid="bulk-actions-button">
          {`Actions \u00A0(${selectedItems.length})`}
        </PrimaryDropDown>
      </Menu.Target>

      <Menu.Dropdown>
        {Object.entries(actions).map(([label, action]) => {
          const icon = menuIcons?.[label];

          return (
            <Menu.Item
              key={label}
              icon={icon}
              onClick={() => {
                action();
                clearSelectedItems();
              }}
            >
              {label}
            </Menu.Item>
          );
        })}
      </Menu.Dropdown>
    </Menu>
  )
}

export default BulkActionsButton